// src/features/locker-assignments/components/forms/HotelSelectionSection.tsx
import React from 'react';
import {
  Box,
  Typography,
  Grid,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from '@mui/material';
import type { Hotel, ReferenceField } from '../../types';

interface HotelSelectionSectionProps {
  selectedHotel: Hotel | null;
  hotels: Hotel[] | undefined;
  loadingHotels: boolean;
  referenceFields: ReferenceField[];
  referenceValues: Record<string, any>;
  onHotelChange: (event: any) => void;
  onReferenceValueChange: (key: string, value: any) => void;
}

export const HotelSelectionSection: React.FC<HotelSelectionSectionProps> = ({
  selectedHotel,
  hotels,
  loadingHotels,
  referenceFields,
  referenceValues,
  onHotelChange,
  onReferenceValueChange,
}) => {
  return (
    <Grid container spacing={2} alignItems="center" sx={{ mb: 2, p: 2 }}>
      <Grid item xs={12} md={3} sx={{ display: 'flex' }}>
        <FormControl fullWidth size="small" variant="outlined">
          <InputLabel id="hotel-select-label">Select Hotel</InputLabel>
          <Select
            labelId="hotel-select-label"
            value={selectedHotel?.id || ''}
            onChange={onHotelChange}
            label="Select Hotel"
            disabled={loadingHotels}
          >
            {hotels?.map((hotel) => (
              <MenuItem key={hotel.id} value={hotel.id}>
                <Box>
                  <Typography>{hotel.name}</Typography>
                </Box>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} md={9}>
        {selectedHotel && referenceFields.length > 0 && (
          <Box>
            <Grid container spacing={2}>
              {referenceFields.map((field, index) => {
                return (
                  <Grid 
                    item 
                    xs={12} 
                    sm={6} 
                    md={4} 
                    key={`${field.key}_${index}_${selectedHotel.id}`}
                  >
                    <TextField
                      id={`reference-field-${field.key}-${index}`}
                      label={field.label}
                      value={referenceValues[field.key] || ''}
                      onChange={(e) => {
                        e.stopPropagation();
                        onReferenceValueChange(field.key, e.target.value);
                      }}
                      type={field.fieldType === 'number' ? 'number' : 'text'}
                      variant="outlined"
                      size="small"
                      fullWidth
                      required={field.isMandatory}
                      InputProps={{
                        autoComplete: 'off',
                      }}
                    />
                  </Grid>
                );
              })}
            </Grid>
          </Box>
        )}
      </Grid>
    </Grid>
  );
};